import { useAuthorizationStore } from '#stores/useAuthStore.js'
/**
 * @param {string} token - The token to insert into headers
 * @returns {object} - The populated headers
 */
export default function getHeaders(token) {
	const auth = useAuthorizationStore()
	const user = auth.user
	return {
		Accept: 'application/json',
		Authorization: token ? `Bearer ${token}` : 'Bearer',
		'X-localization': user.system_language_key ?? localStorage.language,
		'X-fqdn':
			window.location.hostname === 'localhost' ? 'local.host.fqdn' : window.location.hostname,
		'X-Requested-With': 'XMLHttpRequest',
	}
}
